import * as React from 'react';
import { ReactElement } from 'react';
import { ReferrerAccountWrapper, ReferrerAccountInfo } from './ReferrerAccountContainer.styled';
import { Divider } from 'components/common/Divider';
import { getUtcUsFormatDate } from 'modules/utils/time';

interface Props {
  referrers: {
    refereeUserId: number;
    refererUserId: number;
    referrerEmail: string;
    degree: number;
    type: number;
    startDateTime: string;
    endDateTime: string;
  }[];
}

const isExpired = (expiredDate: string): boolean => {
  const today = new Date();
  const dateToCheck = new Date(expiredDate);
  today.setHours(0, 0, 0, 0);
  dateToCheck.setHours(0, 0, 0, 0);
  return dateToCheck < today;
};

const ReferrerAccountContainer = ({ referrers }: Props): ReactElement => {
  const getReferrralAccountInfo = (account: {
    referrerEmail: string;
    startDateTime: string;
    endDateTime: string;
  }) => {
    return `${account.referrerEmail} (${getUtcUsFormatDate(
      account.startDateTime,
    )} ~ ${getUtcUsFormatDate(account.endDateTime)})`;
  };
  
  return (
    <ReferrerAccountWrapper>
      {referrers.map((account, idx) => {
        const hasNext = idx < referrers.length - 1;
        return (
          <React.Fragment key={account.referrerEmail}>
            <ReferrerAccountInfo isExpired={isExpired(account.endDateTime)}>
              {getReferrralAccountInfo(account)}
            </ReferrerAccountInfo>
            {hasNext && (
              <Divider orientation="vertical" flexItem mx={2} style={{ backgroundColor: '#000' }} />
            )}
          </React.Fragment>
        );
      })}
    </ReferrerAccountWrapper>
  );
};

export default ReferrerAccountContainer;
